module.exports = __webpack_public_path__ + "static/media/distribuicao-2.642fe3d2.jpg";